import React from 'react';
import styled from 'styled-components/native';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import { AppButton } from '@/components/base/app.button';
import { openURL } from '../../utils';
import { Modal, ModalProps } from 'react-native';
import { SafeAreaView } from '@/components/base/safe.area.view';

interface Props extends ModalProps {
  changeLog: string;
  downloadLink: string;
  forceUpdate: boolean;
}
export function UpdateModal({ changeLog, downloadLink, forceUpdate, ...rest }: Props) {
  return (
    <Modal {...rest} onRequestClose={rest.onRequestClose}>
      <SafeAreaView>
        <MainBox>
          <Box>
            <UpdateDescription text={'نسخه جدیدی از برنامه منتشر شده است. لطفاً برای استفاده از امکانات جدید برنامه را بروزرسانی کنید.'} />
            {changeLog ? (
              <ChangeLogBox>
                <ChangeLogTitle text={'تغییرات نسخه جدید:'} bold />
                <ChangeLogText text={changeLog} />
              </ChangeLogBox>
            ) : null}
          </Box>
          <ButtonBox>
            <AppButton
              title={'بروزرسانی'}
              variant={'primary'}
              rounded
              onPress={() => {
                openURL(downloadLink);
              }}
            />
            {!forceUpdate && <AppButton title={'بعداً'} variant={'grey'} mode={'outlined'} rounded onPress={rest.onRequestClose} />}
          </ButtonBox>
        </MainBox>
      </SafeAreaView>
    </Modal>
  );
}

const MainBox = styled(Box)`
  padding: 20px;
  flex-grow: 1;
  justify-content: space-between;
`;

const UpdateDescription = styled(AppTextView)`
  text-align: center;
  margin-bottom: 20px;
  line-height: 22px;
`;

const ChangeLogBox = styled(Box)`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 20px;
`;

const ChangeLogTitle = styled(AppTextView)`
  margin-bottom: 8px;
`;

const ChangeLogText = styled(AppTextView)`
  line-height: 20px;
  text-align: right;
`;

const ButtonBox = styled(Box)`
  gap: 10px;
`;
